import React from 'react';
import { useNavigate } from 'react-router-dom';
import LandingPageHeader from "../components/LandingPageHeader";
import LandingPageFooter from "../components/LandingPageFooter";

function PaymentFailure() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-red-100 to-red-300">
      <LandingPageHeader />
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8">
          <div className="text-center">
            <div className="mx-auto mb-4">
              <svg className="w-16 h-16 text-red-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Payment Failed</h2>
            <p className="text-gray-600 mb-8">We're sorry, but your payment could not be processed. Please try again.</p>
            
            <button
              onClick={() => navigate('/pre-book')}
              className="w-full bg-purple-600 text-white rounded-md py-3 px-4 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-400 focus:ring-opacity-75 transition-colors"
            >
              Try Again
            </button>
          </div>
        </div>
      </main>
      <LandingPageFooter />
    </div>
  );
}

export default PaymentFailure;